module.exports = __webpack_public_path__ + "static/media/question-circle.b30cd145.svg";